<template>
  <v-container fluid>
    <v-layout row justify-space-around>
        <v-flex xs12 md12 pb-3>
            <h1>Notification Configuration</h1>
        </v-flex>
    </v-layout>
    <v-layout row>
        <v-flex xs12 md12>
            <SimpleCard>
                <v-layout column>
                    <v-flex xs12 md12>
                        <v-tabs icons-and-text v-model="currentType">
                            <v-tabs-slider />
                            <v-tab href="#sms" class="text-none">
                                SMS
                                <v-icon>textsms</v-icon>
                            </v-tab>
                            <v-tab href="#push" class="text-none">
                                Push
                                <v-icon>notifications</v-icon>
                            </v-tab>
                        </v-tabs>
                    </v-flex>
                    <v-flex xs12 md12 pt-2>
                        <v-tabs-items v-model="currentType">
                            <v-tab-item value="sms"> 
                                <v-card-text  v-if="errored">
                                    Error getting data from the API, please try again later
                                </v-card-text>
                                <section v-else>
                                    <v-progress-circular
                                        v-if="loading"
                                        :size="70"
                                        :width="7"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                    <MessageList 
                                        v-else 
                                        :messages="messages" 
                                        :prettyFields="prettyFields" 
                                        currentType="sms" 
                                        key="sms"
                                    />
                                </section>
                            </v-tab-item>
                            <v-tab-item value="push">
                                <v-card-text  v-if="errored">
                                    Error getting data from the API, please try again later
                                </v-card-text>
                                <section v-else>
                                    <v-progress-circular
                                        v-if="loading"
                                        :size="70"
                                        :width="7"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                    <MessageList 
                                        v-else 
                                        :messages="messages" 
                                        :prettyFields="prettyFields" 
                                        currentType="push" 
                                        key="push"
                                    />
                                </section>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-flex>
                </v-layout>
            </SimpleCard>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/*

*/
import SimpleCard from "@/components/widget/SimpleCard";
import MessageList from "@/components/settings/messages_emails/MessageList.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
    name: "notifications",
    components: {
        MessageList,
        SimpleCard
    },
    data: function() {
        return {
            messages: null,
            prettyFields: {},
            loading: true,
            errored: false,
            currentType: "sms"
        };
    },
    methods: {
        getPrettyFields: async function() {
            let self = this;
            let url = `${this.$store.state.apiUrl}/notificationConfig/getPrettyFieldNames`;
            axios({
                url: url,
                method: "GET",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then(function(response) {
                if(response.data.error == "no_error") {
                    self.prettyFields = response.data.prettyFieldNames;
                } else {
                    console.log("Failed to get pretty field names, continuing...")
                }
            }).catch(function(error) {
                console.log(error)
                console.log("Failed to get pretty field names, continuing...")
            });
        },
        getMessages: async function() {
            let self = this;
            let url = `${this.$store.state.apiUrl}/notificationConfig/${this.currentType}/getAll`;
            this.loading = true;
            axios({
                url: url,
                method: "GET",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then(function(response) {
                if(response.data.error == "no_error") {
                    self.messages = response.data.messages;
                    self.loading = false;
                } else {
                    self.errored = true;
                    console.log(response.data.error)
                    console.log("Failed to get " + self.currentType + " messages")
                }
            }).catch(function(error) {
                self.errored = true;
                console.log(error)
                console.log("Failed to get " + self.currentType + " messages")
            });
        }
    },
    mounted: function() {
        this.getPrettyFields();
        this.getMessages();
    },
    watch: {
        currentType: function() {
            console.log("Getting new messages")
            this.getMessages();
        }
    }
};
</script> 